import { TemplatesAgentWidgetSchemaKey } from '@inference.engine/widgets/web';
import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
  type WidgetActionSchema,
} from '@/entities/widget';
import { EmailFlowWidgetItemData } from '@inference.engine/widgets';

/**
 * Factory that binds the TemplatesAgent widget processor to the supplied dep
 * surface. Returns the processor list consumed by the central widget
 * dispatcher in `features/widgets/processors/`.
 *
 * The widget slice MUST NOT
 * value-import `widgetProcessorDeps` from `@/features/widgets/processors/...`
 * (that would be a cross-feature OUT). The dispatcher (which owns the deps
 * binding) calls this factory and supplies the deps.
 *
 * The TemplatesAgent processor reuses the EmailFlow widget data shape
 * (`EmailFlowWidgetItemData`) as a TYPE-only import from the canonical
 * `@inference.engine/widgets` package — NOT from the EmailFlow feature slice.
 * This keeps cross-widget VALUE OUT at zero.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const create: WidgetActionProcessor<WidgetActionSchema<EmailFlowWidgetItemData>> = {
    key: TemplatesAgentWidgetSchemaKey,
    processor: makeCreateWidgetAction(deps),
  };
  return [create];
};
